/* TinyOops extras v7 (5.9.2026)
   1) Removes Add to cart + cart drawer (mobile freeze fix). Buy now stays.
   2) Swipeable gallery + everyday strip, arrows inside the frame, hidden when there is nothing to scroll.
   3) Smooth in-page scrolling.
   4) Bundle cards: more room, clearer selected state, honest "+N FREE" pill on a clean product photo.
   5) Review cards without photos.
   6) Photos crop from the top so dogs' heads stay in frame.
   7) Shelter-tested badge visible on mobile, next to the rating.
   v7 fix: the everyday-life marquee is now found by animation name, not by the serialized shorthand string. */
(function () {
  'use strict';
  var SINGLE = 'https://cdn.shopify.com/s/files/1/1013/4418/2646/files/tinyoops-mat-single.png?v=1788014989';
  function ready(fn) { document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }

  ready(function () {
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) document.documentElement.style.scrollBehavior = 'smooth';

    var css = document.createElement('style');
    css.textContent =
      '.to-track{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;overscroll-behavior-x:contain;scrollbar-width:none;-webkit-overflow-scrolling:touch}' +
      '.to-track::-webkit-scrollbar{display:none}' +
      '.to-arrow{position:absolute;top:50%;transform:translateY(-50%);width:42px;height:42px;border-radius:50%;background:#FFFDF8;border:2px solid #26241F;box-shadow:3px 3px 0 #26241F;font:800 22px/1 "Bricolage Grotesque",sans-serif;color:#26241F;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0 0 3px;z-index:3}' +
      '.to-arrow:hover{background:#EEF0D5}.to-arrow:active{transform:translateY(-50%) translate(2px,2px);box-shadow:1px 1px 0 #26241F}.to-arrow[hidden]{display:none}' +
      '.to-pkg{transition:background .18s ease,box-shadow .15s ease}' +
      '.to-pkg:not(.is-sel){background:#FFFDF8!important;border-color:rgba(38,36,31,.42)!important;box-shadow:2px 2px 0 rgba(38,36,31,.28)!important}' +
      '.to-pkg.is-sel{background:#EEF0D5!important;border-color:#26241F!important;box-shadow:5px 5px 0 #26241F!important}' +
      '.to-pkg .to-selpill{display:none;position:absolute;top:-13px;right:14px;align-items:center;padding:4px 11px;background:#A8AD4D;border:2px solid #26241F;border-radius:999px;font:800 10px/1 "Bricolage Grotesque",sans-serif;letter-spacing:.06em;text-transform:uppercase;color:#26241F}' +
      '.to-pkg.is-sel .to-selpill{display:inline-flex}' +
      '.to-thumb{position:relative;background:#fff}.to-thumb img{object-fit:contain!important;padding:4px}' +
      '.to-free{position:absolute;right:-5px;bottom:-5px;padding:3px 7px;background:#B2624A;color:#F7F4EE;border:2px solid #26241F;border-radius:999px;font:800 9px/1 "Bricolage Grotesque",sans-serif}' +
      '@media (max-width:1079.98px){.trust-hdr.to-inline{display:inline-flex!important;padding:5px 11px!important;font-size:11px}}';
    document.head.appendChild(css);

    var root = document.querySelector('[data-dc-root="product"]');

    function fixCrop(scope) {
      scope.querySelectorAll('img').forEach(function (im) {
        var box = im.parentElement; if (!box) return;
        if (getComputedStyle(im).objectFit !== 'cover') return;
        var r = box.getBoundingClientRect(); if (!r.width || !r.height) return;
        var ratio = r.width / r.height;
        if (ratio > 1.12) im.style.objectPosition = '50% 22%';
        else if (ratio < 0.9) im.style.objectPosition = '50% 30%';
      });
    }
    setTimeout(function () { fixCrop(document); }, 120);

    if (!root) return;

    root.querySelectorAll('[data-dc-click="addToCart"]').forEach(function (b) { b.remove(); });
    ['#to-cart', '#to-cart-overlay'].forEach(function (s) { var e = document.querySelector(s); if (e) e.remove(); });
    document.body.classList.remove('to-cart-open');
    document.body.style.overflow = '';

    var rev = document.querySelector('#reviews');
    if (rev) rev.querySelectorAll('img').forEach(function (im) { var d = im.closest('div'); if (d) d.remove(); });

    var first = root.querySelector('[data-dc-click="pkg1"]');
    if (first) {
      var list = first.parentElement;
      list.style.gap = '24px';
      list.style.marginTop = '20px';
      var freeText = { 0: '', 1: '+3 FREE', 2: '+1 FREE' };
      var cards = [];
      var mark = function (i) { cards.forEach(function (c, k) { if (c) c.classList.toggle('is-sel', k === i); }); };
      [0, 1, 2].forEach(function (i) {
        var b = root.querySelector('[data-dc-click="pkg' + i + '"]');
        if (!b) return;
        b.classList.add('to-pkg');
        cards[i] = b;
        var pill = document.createElement('span');
        pill.className = 'to-selpill';
        pill.textContent = '\u2713 Selected';
        b.appendChild(pill);
        var thumb = b.querySelector('span > img');
        if (thumb) {
          thumb.src = SINGLE;
          var wrap = thumb.parentElement;
          wrap.classList.add('to-thumb');
          if (freeText[i]) {
            var f = document.createElement('b');
            f.className = 'to-free';
            f.textContent = freeText[i];
            wrap.appendChild(f);
          }
        }
        b.addEventListener('click', function () { mark(i); });
      });
      mark(1);
    }

    var trust = root.querySelector('.trust-hdr');
    var rating = [].slice.call(root.querySelectorAll('div')).filter(function (d) {
      return d.children.length > 1 && /2,400\+ reviews/.test(d.textContent) && d.textContent.length < 90;
    })[0];
    if (trust && rating && innerWidth < 1080) { trust.classList.add('to-inline'); rating.appendChild(trust); }

    function makeTrack(track, wrap, stepFn, onIndex) {
      track.classList.add('to-track');
      var prev = document.createElement('button'), next = document.createElement('button');
      prev.type = next.type = 'button';
      prev.className = next.className = 'to-arrow';
      prev.innerHTML = '\u2039'; next.innerHTML = '\u203a';
      prev.setAttribute('aria-label', 'Previous'); next.setAttribute('aria-label', 'Next');
      prev.style.left = '12px'; next.style.right = '12px';
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
      wrap.appendChild(prev); wrap.appendChild(next);
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.hidden = max <= 0 || track.scrollLeft <= 2;
        next.hidden = max <= 0 || track.scrollLeft >= max;
        if (onIndex) onIndex(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -stepFn(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: stepFn(), behavior: 'smooth' }); });
      var raf = null;
      track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; update(); }); }, { passive: true });
      window.addEventListener('resize', update);
      setTimeout(update, 80);
      setTimeout(update, 1000);
    }

    var stage = root.querySelector('.gal-sticky > div');
    if (stage) {
      var imgs = [].slice.call(stage.querySelectorAll('img'));
      var badge = stage.querySelector('span');
      if (imgs.length > 1) {
        var wrap = document.createElement('div');
        wrap.style.position = 'relative';
        var track = document.createElement('div');
        track.setAttribute('aria-label', 'Product photos');
        track.style.cssText = 'border-radius:20px;background:#FFFDF8;border:2px solid #26241F;aspect-ratio:1/1;overflow:hidden';
        imgs.forEach(function (im) {
          im.removeAttribute('data-dc-style');
          im.style.cssText = 'flex:none;width:100%;height:100%;object-fit:cover;scroll-snap-align:start;display:block;opacity:1;position:static';
          track.appendChild(im);
        });
        wrap.appendChild(track);
        if (badge) wrap.appendChild(badge);
        stage.parentNode.replaceChild(wrap, stage);
        var thumbs = [].slice.call(root.querySelectorAll('[data-dc-click^="img"]'));
        var markImg = function (i) { thumbs.forEach(function (t, k) { var r = t.querySelector('span'); if (r) r.style.opacity = k === i ? '1' : '0'; }); };
        makeTrack(track, wrap, function () { return track.clientWidth; }, markImg);
        thumbs.forEach(function (t, k) { t.addEventListener('click', function () { track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); markImg(k); }, true); });
        markImg(0);
      }
    }

    /* everyday-life marquee: the image strip is the mq animation that lasts 42s (the text strips are 32s/34s) */
    var mq = [].slice.call(root.querySelectorAll('div')).filter(function (d) {
      var s = d.style;
      return s.animationName === 'mq' && /^42s/.test(s.animationDuration || '') && d.querySelector('img');
    })[0];
    if (mq) {
      var seen = {}, keep = [];
      [].slice.call(mq.children).forEach(function (c) {
        var im = c.querySelector('img'); if (!im || seen[im.src]) return; seen[im.src] = 1; keep.push(c);
      });
      mq.style.animation = 'none';
      mq.style.width = 'auto';
      mq.style.padding = '0 clamp(12px,3vw,24px)';
      mq.innerHTML = '';
      keep.forEach(function (c) { c.style.scrollSnapAlign = 'start'; mq.appendChild(c); });
      mq.setAttribute('aria-label', 'Everyday photos');
      var outer = mq.parentElement;
      outer.style.overflow = 'visible';
      makeTrack(mq, outer, function () { return Math.max(160, Math.round(mq.clientWidth * 0.8)); });
    }

    setTimeout(function () { fixCrop(document); }, 400);
  });
})();
